import request from '@/plugin/axios'

export function QuerySysArea (params) {
  return request({
    url: '/v1/nh/fenqu/webArchivemanageSubareamanage/getList',
    method: 'get',
    params
  })
}

export function UpdateSysArea (data) {
  return request({
    url: '/v1/nh/fenqu/webArchivemanageSubareamanage/updateWebArchivemanageSubareamanage',
    method: 'put',
    data
  })
}

export function saveSysArea (data) {
  return request({
    url: '/v1/nh/fenqu/webArchivemanageSubareamanage/addWebArchivemanageSubareamanage',
    method: 'post',
    data
  })
}
export function deleteSysArea (data) {
  return request({
    url: '/v1/nh/fenqu/webArchivemanageSubareamanage/deleteWebArchivemanageSubareamanage',
    headers: {
      'Content-Type': 'x-www-form-urlencoded'
    },
    method: 'delete',
    params: data
  })
}
